<template>
  <div class="deauth-tg-hint">
    <h2 class="deauth-tg-hint__title">Как настроить отправку от бота</h2>
    <v-expansion-panels
      v-model="openedPanels"
      accordion
      flat
      class="deauth-tg-hint__panels"
    >
      <v-expansion-panel>
        <v-expansion-panel-header>
          Отправка в личный чат Telegram
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <ol class="deauth-tg-hint__list">
            <li>
              Перейдите по ссылке
              <a
                class="deauth-tg-hint__link"
                href="https://t.me/dh_smart_bot"
                target="_blank"
                rel="noopener noreferrer"
              >https://t.me/dh_smart_bot</a>
              <div class="deauth-tg-hint__figure">
                <div
                  v-if="imageLoading.personalBotLink"
                  class="deauth-tg-hint__figure-loader"
                >
                  <v-progress-circular
                    indeterminate
                    color="mainNew"
                    size="40"
                    width="3"
                  />
                </div>
                <img
                  src="https://dataheroes.platrum.ru/wiki/api/article/file?file_id=832d3a65fad192e5ff0cee04f0b1be34&article_id=5287"
                  alt="Поиск бота в Telegram"
                  :class="['deauth-tg-hint__image', { 'deauth-tg-hint__image--ready': !imageLoading.personalBotLink }]"
                  @load="onHintImageLoaded('personalBotLink')"
                />
              </div>
            </li>
            <li>В чате с ботом отправьте <strong>/start</strong> или нажмите на кнопку <strong>СТАРТ/Запустить</strong></li>
            <li>Нажмите кнопку <strong>Поделиться номером</strong> и подтвердите</li>
            <li>
              В ответ придет «Спасибо»
              <div class="deauth-tg-hint__figure">
                <div
                  v-if="imageLoading.personalThankYou"
                  class="deauth-tg-hint__figure-loader"
                >
                  <v-progress-circular
                    indeterminate
                    color="mainNew"
                    size="40"
                    width="3"
                  />
                </div>
                <img
                  src="https://dataheroes.platrum.ru/wiki/api/article/file?file_id=02e3f510d61b0e0c0421aaaaffcfb189&article_id=5287"
                  alt="Ответ бота"
                  :class="['deauth-tg-hint__image', { 'deauth-tg-hint__image--ready': !imageLoading.personalThankYou }]"
                  @load="onHintImageLoaded('personalThankYou')"
                />
              </div>
            </li>
            <li>Вернитесь на страницу настройки, закрыв сайдбар, и введите номер телефона в формате +7 (111) 111-11-11 или никнейм из Telegram в формате @name в пустое поле «Телефон / @Никнейм / ID группы». Затем нажмите <strong>Проверить</strong></li>
          </ol>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Отправка в групповой чат Telegram
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <ol class="deauth-tg-hint__list">
            <li>
              Добавьте бота
              <a
                class="deauth-tg-hint__link"
                href="https://t.me/dh_smart_bot"
                target="_blank"
                rel="noopener noreferrer"
              >@dh_smart_bot</a>
              в групповой чат как участника
              <div class="deauth-tg-hint__figure">
                <div
                  v-if="imageLoading.groupStart1"
                  class="deauth-tg-hint__figure-loader"
                >
                  <v-progress-circular
                    indeterminate
                    color="mainNew"
                    size="40"
                    width="3"
                  />
                </div>
                <img
                  src="https://dataheroes.platrum.ru/wiki/api/article/file?file_id=471cfd05d7fbe0f35aaf5fef00788155&article_id=5287"
                  alt="Добавление бота в группу"
                  :class="['deauth-tg-hint__image', 'deauth-tg-hint__image--narrow', { 'deauth-tg-hint__image--ready': !imageLoading.groupStart1 }]"
                  @load="onHintImageLoaded('groupStart1')"
                />
              </div>
              <div class="deauth-tg-hint__figure">
                <div
                  v-if="imageLoading.groupStart2"
                  class="deauth-tg-hint__figure-loader"
                >
                  <v-progress-circular
                    indeterminate
                    color="mainNew"
                    size="40"
                    width="3"
                  />
                </div>
                <img
                  src="https://dataheroes.platrum.ru/wiki/api/article/file?file_id=d276ba49582c4cab4f82744c5259863a&article_id=5287"
                  alt="Бот в списке"
                  :class="['deauth-tg-hint__image', 'deauth-tg-hint__image--narrow', { 'deauth-tg-hint__image--ready': !imageLoading.groupStart2 }]"
                  @load="onHintImageLoaded('groupStart2')"
                />
              </div>
            </li>
            <li>
              В групповом чате с ботом отправьте <strong>/start</strong>
            </li>
            <li>
              В ответ придет такое уведомление
              <div class="deauth-tg-hint__figure">
                <div
                  v-if="imageLoading.groupNotification"
                  class="deauth-tg-hint__figure-loader"
                >
                  <v-progress-circular
                    indeterminate
                    color="mainNew"
                    size="40"
                    width="3"
                  />
                </div>
                <img
                  src="https://dataheroes.platrum.ru/wiki/api/article/file?file_id=85baf82874674596f21f8b09d6d2bb31&article_id=5328"
                  alt="Ответ бота"
                  :class="['deauth-tg-hint__image', { 'deauth-tg-hint__image--ready': !imageLoading.groupNotification }]"
                  @load="onHintImageLoaded('groupNotification')"
                />
              </div>
            </li>
            <li>
              Скопируйте ID (не удаляйте дефис перед ID), которое вам прислал бот кликнув по нему. Вернитесь на страницу настройки, закрыв сайдбар, и вставьте скопированный ID в пустое поле «Телефон / @Никнейм / ID группы». Затем нажмите <strong>Проверить</strong>
            </li>
          </ol>
          <p class="mt-2"><strong><u>Важно!</u></strong> В любой момент вы можете узнать ID группы повторно, отправив в чате с ботом <strong>/groupid</strong></p>
          <p>
            <div class="deauth-tg-hint__figure">
              <div
                v-if="imageLoading.groupIdHint"
                class="deauth-tg-hint__figure-loader"
              >
                <v-progress-circular
                  indeterminate
                  color="mainNew"
                  size="40"
                  width="3"
                />
              </div>
              <img
                src="https://dataheroes.platrum.ru/wiki/api/article/file?file_id=81993d01d279269e0ccb845658870115&article_id=5328"
                alt="Повторно узнать id гурппы"
                :class="['deauth-tg-hint__image', { 'deauth-tg-hint__image--ready': !imageLoading.groupIdHint }]"
                @load="onHintImageLoaded('groupIdHint')"
              />
            </div>
          </p>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
const HINT_IMAGE_KEYS = [
  'personalBotLink',
  'personalThankYou',
  'groupStart1',
  'groupStart2',
  'groupNotification',
  'groupIdHint',
]

export default {
  name: 'DeauthTgHint',
  data: () => ({
    // По умолчанию обе панели свернуты.
    openedPanels: [],
    imageLoading: HINT_IMAGE_KEYS.reduce((acc, key) => {
      acc[key] = true
      return acc
    }, {}),
  }),
  methods: {
    onHintImageLoaded(key) {
      this.$set(this.imageLoading, key, false)
    },
  },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.deauth-tg-hint
  color: #2A3B51
  width: 100%

.deauth-tg-hint__title
  font-size: 22px
  line-height: 28px
  font-weight: 500
  margin-bottom: 12px

.deauth-tg-hint__panels
  width: 100%

.deauth-tg-hint__link
  color: $main
  text-decoration: underline

.deauth-tg-hint__list
  margin: 0
  padding-left: 20px

// Выровнять с краем контента панели, без отступа номера списка
.deauth-tg-hint__list-note
  margin-top: 8px
  margin-bottom: 8px
  margin-left: -20px
  width: calc(100% + 20px)

.deauth-tg-hint__figure
  position: relative
  width: 100%
  margin-top: 8px
  min-height: 60px

.deauth-tg-hint__figure-loader
  position: absolute
  inset: 0
  display: flex
  align-items: center
  justify-content: center
  z-index: 1

.deauth-tg-hint__image
  width: 100%
  max-width: 100%
  display: block
  height: auto
  opacity: 0
  transition: opacity 0.2s ease

.deauth-tg-hint__image--narrow
  width: 80%
  margin-left: auto
  margin-right: auto

.deauth-tg-hint__image--ready
  opacity: 1

::v-deep .deauth-tg-hint__panels
  .v-expansion-panel
    width: 100%
    border: 1px solid #2A3B5161
    border-radius: 4px !important
    margin-bottom: 12px
    box-shadow: none !important

  .v-expansion-panel::before
    box-shadow: none !important

  .v-expansion-panel-header
    font-weight: 600
    font-size: 18px
    color: $text-color
</style>
